import { Box, Grid, TextField } from "@mui/material";
import { useRefresh } from "react-admin";
import HeaderLabelTitle from "../../unit/HeaderLabelTitle";
import { useEffect, useState } from "react";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonSave from "../../unit/CustomButtonSave";
import useNotify from "../../unit/useNotify";
import CustomSelectVerify from "../../unit/forms/CustomSelectVerify";
import CustomTextField from "../../unit/forms/CustomTextField";
const CustomToNotifyVendorDialog = (props: any) => {
  const record = props.record;
  const appId = record?.id;
  const loan = record?.loan;
  const appAttrs = record?.attrs;
  const { successNotify, errorNotify, infoNotify } = useNotify();

  const [purchaseInfo, setPurchaseInfo] = useState<any>({});
  const [userPurchaseDataProduct, setUserPurchaseDataProduct] = useState<any>(
    []
  );
  const [defaultVendorList, setDefaultVendorList] = useState<
    { label: any; value: any }[]
  >([{ label: "Select Vendor", value: "" }]);
  const [vendor, setVendor] = useState("");
  const [subFormData, setSubFormData] = useState<any>({});
  const [product_total_price, setProduct_total_price] = useState(0);
  const [borrower_payment_amount, setBorrower_payment_amount] = useState(0);
  const [loan_amount, setLoan_amount] = useState(record.amountReview);
  const refresh = useRefresh();
  const reqUrl = "applications/actions/notify/getPurchaseInfoDetail";
  const getPurchaseInfoDetail = async () => {
    const response = await sendRequest(reqUrl, { id: appId });
    return response;
  };
  useEffect(() => {
    const fetchData = async () => {
      const responseData = await getPurchaseInfoDetail();
      if (responseData && responseData?.code == "200") {
        setPurchaseInfo(responseData);
        if (responseData && responseData.vendorList) {
          responseData.vendorList.map((vendor: any) => {
            if (
              defaultVendorList.findIndex((x) => x.value === vendor.id) === -1
            )
              setDefaultVendorList((prevList) => [
                ...prevList,
                { label: vendor.sName, value: vendor.id },
              ]);
          });
        }
      }
    };
    fetchData();
  }, []);

  if (!purchaseInfo) {
    return <div>Loading...</div>;
  }
  type ProductData = {
    [key: string]: {
      product_name: string;
      product_model: string;
      total_price: string;
    };
  };

  const purchaseSummary = purchaseInfo?.userPurchaseData?.Other;
  useEffect(() => {
    if (purchaseSummary) {
      setProduct_total_price(purchaseSummary.product_total_price);
      setBorrower_payment_amount(purchaseSummary.borrower_payment_amount);
      setLoan_amount(purchaseSummary.loan_amount);
      setVendor(purchaseSummary.vendor_id);
    }
  }, [purchaseSummary]);
  const productArray: ({ key: string; value: any }[] | undefined)[] = [];
  const productObject: any = {};
  if (purchaseInfo?.userPurchaseData?.Product) {
    const productData = purchaseInfo?.userPurchaseData?.Product;
    Object.keys(productData).map((key) => {
      const product = productData[key];
      productArray.push([
        { key: "product_name", value: product.product_name },
        { key: "product_model", value: product.product_model },
        { key: "total_price", value: product.total_price },
      ]);
    });
  }

  const calcToTotalPrice = (value: any) => {
    setLoan_amount(record.loanAmount);
    let total_price = 0;
    document.getElementsByName("total_price").forEach((element) => {
      total_price += Number(
        element?.value?.toString().replace(/,/g, "").replace("$", "")
      );
    });
    total_price = Number(total_price);
    setProduct_total_price(total_price);
    setBorrower_payment_amount(total_price - Number(record.amountReview));
  };

  const handleSaveVendor = async () => {
    let checkSubmit = true;
    let productBody = "";
    if (productArray.length > 0) {
      productArray.map((p: any, index: any) => {
        let product_model = document.getElementById(
          `product_model_${index}`
        )?.value;
        let product_name = document.getElementById(
          `product_name_${index}`
        )?.value;
        let total_price = document.getElementById(
          `total_price_${index}`
        )?.value;

        if (total_price == 0 || total_price == "") {
          const element = document.getElementById(`total_price_${index}`);
          if (element) {
            (element as HTMLElement).style.border = "1px solid red";
          }
          checkSubmit = false;
          return;
        }
        productBody +=
          ",product_name=" +
          product_name +
          ",product_model=" +
          product_model +
          ",total_price=" +
          total_price +
          "|";
      });
    } else {
      let product_model = document.getElementById("product_model_0")?.value;
      let product_name = document.getElementById("product_name_0")?.value;
      let total_price = document.getElementById("total_price_0")?.value;
      if (total_price == 0 || total_price == "") {
        const element = document.getElementById(`total_price_0`);
        if (element) {
          (element as HTMLElement).style.border = "1px solid red";
        }
        checkSubmit = false;
        return;
      }
      productBody +=
        ",product_name=" +
        product_name +
        ",product_model=" +
        product_model +
        ",total_price=" +
        total_price +
        "|";
    }

    if (checkSubmit == false) {
      errorNotify("Please input all fields");
      return false;
    }
    let formJson = {
      vendor_id: vendor,
      product_total_price: product_total_price,
      borrower_payment_amount: borrower_payment_amount,
      loan_amount: Number(record.amountReview),
      product: productBody,
    };

    const reqUrl = `applications/actions/notify/saveBankApplicationPurchaseInfo`;
    const response = await sendRequest(reqUrl, { id: appId, data: formJson });
    if (response && (response.status == "200" || response.code == "200")) {
      successNotify("Deposit Data saved successfully");
      refresh();
    } else {
      errorNotify(response?.message || "Data not saved!");
    }
  };
  return (
    <>
      <Grid container>
        <Grid
          container
          sx={{
            position: "sticky",
            top: "25px",
            zIndex: 2,
            justifyContent: "flex-end",
            // backgroundColor: "#fff",
            pb: 1,
          }}
        >
          <Grid item>
            <CustomButtonSave
              type="submit"
              className="btn btn-primary"
              variant="contained"
              label="Save"
              onClick={handleSaveVendor}
            />
          </Grid>
        </Grid>
        <Grid container sx={{ mb: 2, pb: 2, pt: 2 }}>
          <Grid item xs={3} sx={{ paddingTop: "20px" }}>
            <HeaderLabelTitle title="Vendor (Required)" />
          </Grid>
          <Grid item xs={9}>
            <CustomSelectVerify
              fullWidth={true}
              id="vendor_id"
              name="vendor_id"
              optionlist={defaultVendorList}
              // required={true}
              variant="outlined"
              value={vendor}
              onChange={(e) => {
                setVendor(e.target.value);
              }}
              helperText={"no"}
            />
          </Grid>
          <Grid item xs={3}></Grid>
          <Grid item xs={3}></Grid>
        </Grid>
        <Grid container sx={{ px: 1 }}>
          <Grid sx={{ mb: 2 }} container>
            <Grid item xs={3}>
              <HeaderLabelTitle title="Product #" suffix="" />
            </Grid>
            <Grid item xs={3}>
              <HeaderLabelTitle title="Product Name" suffix="" />
            </Grid>
            <Grid item xs={3}>
              <HeaderLabelTitle title="Product Model" suffix="" />
            </Grid>
            <Grid item xs={3}>
              <HeaderLabelTitle title="Total Price" suffix="" />
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={1} sx={{ mb: 1 }}>
          {productArray.map((p: any, index: any) => (
            <>
              <Grid item xs={3}></Grid>
              {p.map((item: any, subIndex: any) => (
                <Grid item xs={3} key={`${index}-${subIndex}`}>
                  <CustomTextField
                    id={`${item.key}_${index}`}
                    name={item.key}
                    defaultValue={item.value}
                    required={true}
                    helperText={"no"}
                    variant="outlined"
                    onChange={(e) => {
                      if (item.key == "total_price") {
                        calcToTotalPrice(e.target.value);
                      }
                    }}
                    sx={{ mt: 0, pt: 0 }}
                  />
                </Grid>
              ))}
            </>
          ))}
        </Grid>
        <Grid container spacing={1} sx={{ mb: 1 }}>
          {!productArray.length && (
            <>
              <Grid item xs={3}></Grid>
              <Grid item xs={3}>
                <CustomTextField
                  id="product_model_0"
                  name="product_model"
                  fullWidth
                  required={true}
                  helperText={"no"}
                  variant="outlined"
                  sx={{ mt: 0, pt: 0 }}
                />
              </Grid>
              <Grid item xs={3}>
                <CustomTextField
                  id="product_name_0"
                  name="product_name"
                  fullWidth
                  required={true}
                  helperText={"no"}
                  variant="outlined"
                  sx={{ mt: 0, pt: 0 }}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  id="total_price_0"
                  name="total_price"
                  fullWidth
                  required={true}
                  variant="outlined"
                  onChange={(e) => {
                    calcToTotalPrice(e.target.value);
                  }}
                  sx={{ mt: 0, pt: 0 }}
                />
              </Grid>
            </>
          )}
        </Grid>
        <Grid container spacing={1} sx={{ mb: 1 }}>
          <Grid item xs={9} sx={{ textAlign: "right" }}>
            <Box sx={{ mt: "10px" }}>
              <HeaderLabelTitle title="Total Price" suffix="" />
            </Box>
          </Grid>
          <Grid item xs={3}>
            <TextField
              id="product_total_price"
              name="product_total_price"
              defaultValue={product_total_price}
              value={product_total_price}
              onChange={(e) => {
                setProduct_total_price(Number(e.target.value));
              }}
              fullWidth
              variant="outlined"
              inputProps={{ readOnly: true }}
              sx={{
                "& input[readonly]": {
                  background: "#e5e5e5",
                },
                "& .MuiInputBase-readOnly": {
                  background: "#e5e5e5",
                },
                "& input": { pl: "14px", pt: "8px" },
              }}
            />
          </Grid>
        </Grid>
        <Grid container spacing={1} sx={{ mb: 1 }}>
          <Grid item xs={9} sx={{ textAlign: "right" }}>
            <Box sx={{ mt: "10px" }}>
              <HeaderLabelTitle title="Borrower Pay" suffix="" />
            </Box>
          </Grid>
          <Grid item xs={3}>
            <TextField
              id="borrower_payment_amount"
              name="borrower_payment_amount"
              defaultValue={borrower_payment_amount}
              value={borrower_payment_amount}
              onChange={(e) => {
                setBorrower_payment_amount(Number(e.target.value));
              }}
              fullWidth
              variant="outlined"
              inputProps={{ readOnly: true }}
              sx={{
                "& input[readonly]": {
                  background: "#e5e5e5",
                },
                "& .MuiInputBase-readOnly": {
                  background: "#e5e5e5",
                },
                "& input": { pl: "14px", pt: "8px" },
              }}
            />
          </Grid>
        </Grid>
        <Grid container spacing={1} sx={{ mb: 1 }}>
          <Grid item xs={9} sx={{ textAlign: "right" }}>
            <Box sx={{ mt: "10px" }}>
              <HeaderLabelTitle title="Loan Amount" suffix="" />
            </Box>
          </Grid>
          <Grid item xs={3}>
            <TextField
              id="loan_amount"
              name="loan_amount"
              defaultValue={loan_amount}
              value={loan_amount}
              onChange={(e) => {
                setLoan_amount(Number(e.target.value));
              }}
              fullWidth
              variant="outlined"
              inputProps={{ readOnly: true }}
              sx={{
                "& input[readonly]": {
                  background: "#e5e5e5",
                },
                "& .MuiInputBase-readOnly": {
                  background: "#e5e5e5",
                },
                "& input": { pl: "14px", pt: "8px" },
              }}
            />
          </Grid>
        </Grid>
        {/* save button */}
      </Grid>
    </>
  );
};

export default CustomToNotifyVendorDialog;
